function backToLogin() {
  // @ts-ignore
  if (window?.accessTokenExpired) {
    // @ts-ignore
    window?.accessTokenExpired?.postMessage('');
  }
  // @ts-ignore
  if (window?.flutter_inappwebview) {
    // @ts-ignore
    window?.flutter_inappwebview?.callHandler('accessTokenExpired');
  }
}

export const FLUTTER_FUNCTIONS = {
  backToLogin
};
